// İSG uzmanı portalı — Risk Değerlendirme (Risk) erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir (`[ModuleAction("risk-assessments", …)]`); bu kapı yalnız UX'tir:
// erişim sondasının (useRiskAccess) sonucuna göre Risk alt-ağacını (Outlet: liste + editör +
// detay), 403 sayfasını veya "kullanılamıyor" durumunu gösterir. İş İzni/Eğitim kapılarıyla
// aynı desen; iş modülü olarak AYRIDIR. Gerçek modül Value = `risk-assessments`.

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { ShieldAlert, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { useRiskAccess } from '../../lib/riskAccess';

export function RiskAssessmentsGate() {
  const { t } = useTranslation();
  const access = useRiskAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('risk.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <ShieldAlert className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('risk.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('risk.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('risk.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('risk.unavailable.title')}</h1>
              <p className="text-sm text-muted">{t('risk.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('risk.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
